import React from 'react'
import { TbCross } from "react-icons/tb";


function Splash() {
  return (
    <div className='flex items-center justify-center w-screen h-screen bg-[#7b026b]/20'>

        <TbCross  className='text-[#7b026b]/50 text-[300px]' />
        
    </div>
  )
}

export default Splash